import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
/** Free-text tag entry — Enter or comma commits the current text as a new
 * tag, Backspace on an empty field removes the last one. Plain strings in,
 * plain strings out; callers resolve them against real tag records (or
 * not) themselves. */
export function TagInput({ label, value, onChange, placeholder }) {
    const [draft, setDraft] = useState('');
    const commit = () => {
        const tag = draft.trim();
        if (tag && !value.includes(tag))
            onChange([...value, tag]);
        setDraft('');
    };
    const onKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault();
            commit();
        }
        else if (e.key === 'Backspace' && draft === '' && value.length > 0) {
            onChange(value.slice(0, -1));
        }
    };
    return (_jsxs("div", { className: "flex flex-col gap-1.5", children: [_jsx("span", { className: "text-[13px] font-semibold text-ink", children: label }), _jsxs("div", { className: "flex flex-wrap items-center gap-1.5 rounded-input border border-border-strong bg-surface px-2 py-1.5 focus-within:border-primary focus-within:shadow-focus-ring", children: [value.map((tag) => (_jsxs("span", { className: "flex items-center gap-1 rounded-full bg-neutral-pill-soft px-2 py-0.5 text-xs font-medium text-neutral-pill", children: [tag, _jsx("button", { type: "button", onClick: () => onChange(value.filter((t) => t !== tag)), "aria-label": `Remove ${tag}`, className: "hover:text-danger", children: "\u00D7" })] }, tag))), _jsx("input", { value: draft, onChange: (e) => setDraft(e.target.value), onKeyDown: onKeyDown, onBlur: commit, placeholder: value.length === 0 ? placeholder : undefined, className: "min-w-20 flex-1 border-none bg-transparent py-0.5 text-sm outline-none" })] })] }));
}
//# sourceMappingURL=TagInput.js.map